'use client';

import { GlobalSearchProps } from "./global-search.types";
import { Command, CommandInput, CommandList, CommandEmpty, CommandGroup, CommandItem } from "@/components/ui/command";
import { FC, useRef, useState } from "react";
import { debounce } from "lodash";
import { PDFViewer } from "@/components/ui/pdf-viewer/pdf-viewer.component";
import { InvoiceExtended } from "@/types";
import { Logo } from "@/components/ui/logo";

const GlobalSearch: FC<GlobalSearchProps> = () => {
  const [isSearching, setIsSearching] = useState(false);
  const [searchResults, setSearchResults] = useState<InvoiceExtended[]>([]);
  const searchValueRef = useRef<string>('');

  const handleInvoiceSearch = debounce(async(value: string) => {
    if (value) {
      const invoicesResponse = await fetch(`/api/invoice/search?query=${value}`);
      const invoicesList = await invoicesResponse.json();
      console.log('invoicesList', invoicesList);
      setSearchResults(invoicesList);
    } else {
      setSearchResults([]);
    }
    setIsSearching(false); // Update state after results are set
  }, 300); // Adjust debounce delay as needed


  const onInvoiceSearch = (event: React.KeyboardEvent<HTMLInputElement>) => {
    const value = (event.target as HTMLInputElement).value;
    searchValueRef.current = value;
    setIsSearching(true); // Set searching state
    handleInvoiceSearch(value); // Debounce the search logic
  };

  const selectInvoice = (invoiceId: string) => {
    console.log('selected invoice', invoiceId);
    
  };

  return <div className="invoice-search">
    <div className="framer max-w-[465px] max-h-[700px] overflow-y-auto m-[-4px]">
        <Command className="bg-transparent rounded-sm p-[4px]"  shouldFilter={false} onKeyUp={(event: React.KeyboardEvent<HTMLInputElement>) => onInvoiceSearch(event)}>
          <CommandInput variant="input"  autoFocus placeholder="Search..." >
          </CommandInput>

          <CommandList cmdk-list="true">
            {isSearching ? (
              <CommandEmpty>Searching...</CommandEmpty>
            ) : searchResults.length ? (
              <CommandGroup className='p-0'>
                {searchResults.map((invoice: InvoiceExtended, index: number) => (
                  <CommandItem
                    asChild
                    className='cursor-pointer'
                    cmdk-item="true"
                    key={index}
                    value={invoice.id}
                    onSelect={() => selectInvoice(invoice.id)}
                  >
                    <div className="flex flex-col">
                      <h3>Invoice... {invoice.invoiceId}</h3>
                      {invoice.seller ? <Logo url={invoice.seller.corporateWebsiteURL} shortName={invoice.seller.shortCompanyName} longName={invoice.seller.companyName} /> : undefined}
                      {invoice.documentUrl ? <PDFViewer documentUrl={invoice.documentUrl} width={300} /> : null}
                    </div>
                  </CommandItem>
                ))}
              </CommandGroup>
            ) : searchValueRef.current &&(
              <CommandEmpty>No invoices found for {searchValueRef.current}.</CommandEmpty>
            )}
        </CommandList>
      </Command>
    </div>
  </div>
};

export { GlobalSearch };